import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const ClaimDetail = React.lazy(() => import('../components/ClaimDetail'));
function ClaimDetailView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <ClaimDetail {...props} />
    </Suspense>
  );
}

export default ClaimDetailView;
